

import React from 'react';

function Paso5({ cantidadFaq, asegurarFaqLongitud, faq, actualizarFaq, divisaServicio, BotonesaPasos, setPasoActual, guardarProgreso, }) {


  return(
    <div className="card border-0 shadow-sm">
      <div className="card-body position-relative">
        <div className="d-flex align-items-center gap-2 position-absolute top-0 end-0 m-3">
          <span className="badge rounded-pill border" style={{ backgroundColor: "var(--color-bg-accent-subtle)", color: "var(--color-text-primary)", borderColor: "var(--azul-cielo)", fontWeight: 600 }}>
            {divisaServicio === "USD" ? "🇺🇸 USD" : "🇨🇴 COP"}
          </span>
          <span className="badge text-bg-primary">5 / 5</span>
        </div>
        {/* TITULO */}
        <h3 className='mt-5'>FAQ</h3>
        <p>Responde preguntas frecuentes. Esto reduce mensajes y aumenta conversiones.</p>
        {/* Contenedor titulos */}
        <div className="row g-3 align-items-end">
          {/* dropdown cantidad de preguntas */}
          <div className="col-12 col-md-6">
            <label className="form-label">Cantidad de preguntas</label>
            <select className="form-select" value={cantidadFaq} onChange={(e) => asegurarFaqLongitud(parseInt(e.target.value, 10))} >
              <option value={0}>0 (sin FAQ)</option>
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
              <option value={5}>5</option>
            </select>
            <small className="text-muted">Puedes cambiarlo cuando quieras.</small>
          </div>
          
          {/* aviso de ayuda */}
          <div className="col-12 col-md-6">
            <div className="alert alert-info mb-0" role="alert"> <strong>Tip:</strong> agrega 2-3 preguntas típicas: zonas, horarios, qué incluye y qué no. </div>
          </div>
        </div>
        
        
        {/* ACORDEÓN DE PREGUNTAS */}
        {cantidadFaq > 0 ? (
        <div className="accordion mt-4" id="accordionFaq">
          {Array.from({ length: cantidadFaq }).map((_, idx) => (
            <div className="accordion-item" key={idx}>
              {/* HEADER */}
              <h2 className="accordion-header" id={`faq-h-${idx}`}>
                <button
                  className={`accordion-button ${idx === 0 ? "" : "collapsed"}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#faq-c-${idx}`}
                  aria-expanded={idx === 0 ? "true" : "false"}
                  aria-controls={`faq-c-${idx}`}
                >
                  Pregunta {idx + 1}
                </button>
              </h2>

              {/* BODY */}
              <div id={`faq-c-${idx}`} className={`accordion-collapse collapse ${idx === 0 ? "show" : ""}`} aria-labelledby={`faq-h-${idx}`} data-bs-parent="#accordionFaq" >
                <div className="accordion-body">
                  {/* PREGUNTA */}
                  <div className="mb-3">
                    <label className="form-label">Pregunta</label>
                    <input
                      className="form-control"
                      value={faq[idx]?.pregunta || ""}
                      onChange={(e) => actualizarFaq(idx, "pregunta", e.target.value)}
                      placeholder="Ej: ¿En qué zonas trabajas?"
                      maxLength={120}
                    />
                    <small className="text-muted">Máximo 120 caracteres.</small>
                  </div>

                  {/* RESPUESTA */}
                  <div>
                    <label className="form-label">Respuesta</label>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={faq[idx]?.respuesta || ""}
                      onChange={(e) => actualizarFaq(idx, "respuesta", e.target.value)}
                      placeholder="Ej: Trabajo en Bogotá y alrededores. Confirmo disponibilidad por chat."
                      maxLength={800}
                    />
                    <small className="text-muted">Máximo 800 caracteres.</small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        ) : null}



        {/* Navegación Paso 5 */}
        <BotonesaPasos
          anterior={() => setPasoActual(4)}
          siguiente={() => {}}
          textoSiguiente="Finalizado"
          onGuardar={(incluirPaquetes) => guardarProgreso({ mostrarAlerta: true, incluirPaquetes })}
          incluirPaquetesEnGuardar={true}
          deshabilitarSiguiente={true}
        />
      </div>
    </div>
  );
}


export default Paso5;